import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
`;
